import React from 'react'
import { FileDownloadLink } from '../file'
import { FILE_TYPES, jobStatus } from '@landscape/ui-lib'

export const JobFiles: React.FC<any> = (props: any) => {
  const { id, fileName, statusCode } = props.row
  const column = props.column
  const justify = column.justify || 'start'
  if (statusCode !== jobStatus.DONE) {
    return (
      <>
        <div className={`cb-padding-left-8 display-flex justify-content-${justify}`}>
          {fileName}
        </div>
      </>
    )
  }

  return (
    <FileDownloadLink
      type={FILE_TYPES.JOB}
      jobId={id.toString()}
      originalFileName={fileName}
      ariaLabel="Download job result file"
    />
  )
}
